<script setup lang="ts">
useHead({
  script: [
    { src: 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js', key: 'office-js' },
  ],
})
</script>

<template>
  <div class="h-screen flex flex-col bg-background">
    <slot />
  </div>
</template>
